import React, { useState } from 'react'
import { useEventListener } from 'passiv-libs'
import { RateApp } from 'passiv-components'

// NB trigger with: utils.general.triggerRateApp()
const RateAppWrapper = () => {
  const [show, setShow] = useState(false)
  useEventListener('passiv-rate-app', () => setShow(true))

  return show ? <RateApp onClose={() => setShow(false)} /> : null
}

export default RateAppWrapper
